import isCustomRangeInput from 'isCustomRangeInput';

// Grouped by numeric ranges, a chart's rows come back keyed on `key` (a
// custom bucket's label, or a fixed bucket's lower bound) rather than on the
// dimension's field
export const getTermKey = (chartDef: V5ChartDefinition): string | undefined => {
  const { dimensionA } = chartDef;
  if (!dimensionA) {
    return undefined;
  }
  return dimensionA.rangeInput ? 'key' : dimensionA.field;
};

// A row's term as the chart names it: a custom bucket's label, a fixed
// bucket's "from - to", or the dimension's value
export const toTermName = ({
  chartDef,
  row,
}: {
  chartDef: V5ChartDefinition;
  row: MetricResponse;
}): string => {
  const key = getTermKey(chartDef);
  const value = key ? row[key] : undefined;
  const rangeInput = chartDef.dimensionA && chartDef.dimensionA.rangeInput;
  if (rangeInput && !isCustomRangeInput(rangeInput)) {
    const from = Number(value);
    return `${from} - ${from + rangeInput.fixed}`;
  }
  return value as string;
};
